"use client";
import { useRouter } from "next/navigation";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { use, useEffect, useRef, useState } from "react";
import Select, { SingleValue } from "react-select";
import { HOURS_ARRAY } from "../utils/constants";
import { TIME_ZONES } from "../utils/constants";
import toast, { Toaster } from "react-hot-toast";
// import 'react-datepicker/dist/react-datepicker.css';
// import DatePicker from "react-datepicker";

import tickIcon from "../../../public/images/Tick.svg";
import TimezoneSelect, { ITimezone } from "react-timezone-select";
import moment from "moment-timezone";
import { isValidPhoneNumber } from "libphonenumber-js";
import { InlineWidget } from "react-calendly";
import Link from "next/link";
import { getCookie, setCookie } from "cookies-next";

type OptionType = {
  value: string;
  label: string;
};

const defaultTimezone: any = {
  value: "Asia/Kolkata",
  label: "(GMT+5:30) Chennai, Kolkata, Mumbai, New Delhi",
  offset: 5.5,
  abbrev: "IST",
  altName: "India Standard Time",
};

export default function ContactForm({
  placeholder,
  text,
}: {
  placeholder: string;
  text: string;
}) {
  const router = useRouter();
  const [formData, setFormData] = useState({
    name: "",
    companyName: "",
    officialEmail: "",
    contactNo: "",
    message: "",
    meetingDate: "",
    scheduleMeeting: "",
    startTime: "",
    endTime: "",
    timeZone: defaultTimezone.value,
    hour: "",
  });

  const [error, setError] = useState({
    name: false,
    companyName: false,
    officialEmail: false,
    contactNo: false,
    message: false,
    meetingDate: false,
    scheduleMeeting: false,
    startTime: false,
    endTime: false,
    timeZone: false,
    hour: false,
  });

  const [phoneValue, setPhoneValue] = useState<any | undefined>(undefined);
  const [status, setStatus] = useState<string | null>(null);

  const [isTimezone, setIsTimezone] = useState(false);

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [accordionOpen, setAccordionOpen] = useState(false);
  const [countriesTimeZone, setCountriesTimeZone] = useState<
    { label: string; value: string }[]
  >([]);
  const [selectedHour, setSelectedHour] = useState(null);
  const [countriesHour, setCountriesHour] = useState<
    { label: string; value: string }[]
  >([]);

  const [isloading, setIsLoading] = useState(false);
  const [selected, setSelected] = useState<Date | null>(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const calendarRef = useRef<HTMLDivElement>(null);
  const [startTime, setStartTime] = useState<SingleValue<OptionType>>(null);
  const [endTime, setEndTime] = useState<SingleValue<OptionType>>(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const[validation, setValidation] = useState(false);
  const [isSubmitClicked,setIsSubmitClicked]=useState(false)
  const [isSchedule, setIsSchedule] = useState(false);

 
const addEmailToCookie = (cookieName: string, email: string) => {
  // Get today's date
  const now = new Date();

  // Calculate the expiry date (midnight of the next day)
  const expireAt = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 1
  );

  // Convert local midnight to UTC
  const utcExpireAt = new Date(
    expireAt.getTime() - expireAt.getTimezoneOffset() * 60000
  );

  // Get existing emails from the cookie
  const cookieValue = getCookie(cookieName);
  const existingEmails: string[] =
    cookieValue && typeof cookieValue === "string"
      ? JSON.parse(cookieValue)
      : [];

  // Add new email if it doesn't exist
  if (!existingEmails.includes(email)) {
    existingEmails.push(email);
  }

  // Set the cookie with the updated email array
  setCookie(cookieName, JSON.stringify(existingEmails), {
    expires: utcExpireAt,
    path: "/",
  });
};

  const [selectedTimezone, setSelectedTimezone] =
    useState<ITimezone>(defaultTimezone);

  const handleTimeZoneChange = (timezone: any) => {
    setSelectedTimezone(timezone);
    setFormData({
      ...formData,
      timeZone: timezone ? timezone : defaultTimezone,
    });
    const currentTime = moment.tz(timezone.value).format("HH:mm:ss");
  };

  const isAgree = () => {
    setIsChecked(!isChecked);
  };

  const modalRef = useRef<HTMLDivElement>(null);

  const handleDateChange = (date: any) => {
    setSelected(date);

    setFormData({
      ...formData,
      meetingDate: date ? date : "",
    });
    setIsCalendarOpen(false);
  };

  const handleInputClick = () => {
    setIsCalendarOpen(true);
  };

  const handleClickOutside = (event: any) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setIsCalendarOpen(false);
    }
  };

  const handleStartTimeChange = (selectedOption: any) => {
    setStartTime(selectedOption);
    setEndTime(null);
    setFormData({
      ...formData,
      startTime: selectedOption ? selectedOption.value : "",
    });
  };

  const handleEndTimeChange = (selectedOption: any) => {
    setEndTime(selectedOption);
    setFormData({
      ...formData,
      endTime: selectedOption ? selectedOption.value : "",
    });
  };

  const filteredEndTimeOptions = countriesHour.filter((option) => {
    return !startTime || option.value > startTime.value;
  });

  useEffect(() => {
    if (isCalendarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCalendarOpen]);


  useEffect(() => {
    const options = TIME_ZONES.map((timeZone) => {
      return { value: timeZone, label: timeZone };
    });
    setCountriesTimeZone(options);

    const hourOptions = HOURS_ARRAY.map((hour) => {
      return { value: hour, label: hour };
    });
    setCountriesHour(hourOptions);
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;

    setFormData({ ...formData, [id]: value });
    setError((prevErrors) => ({ ...prevErrors, [id]: false }));
  };

const handleSubmit = async (e: React.FormEvent, isScheduleMeeting: boolean,isformSubmitted:boolean) => {
  e.preventDefault();

  const validateForm = () => {
    const isBlank = (str: string) => !str || str.trim() === "";
    const specialChars = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~1234567890]/;
    const emailPattern =
      /^[A-Za-z0-9._%+-]+@(?!gmail\.com|yahoo\.com|orkut\.com|yopmail\.com|outlook\.com)[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const nameTest = specialChars.test(formData.name);
    const companyNameTest = specialChars.test(formData.companyName);
    const officialEmailTest = emailPattern.test(formData.officialEmail);
    const storedFormEmails = getCookie("formEmails");
    const storedScheduleEmails = getCookie("scheduleEmails");

    
  

        if (isScheduleMeeting) {
          addEmailToCookie("scheduleEmails", formData.officialEmail);
        } else {
          addEmailToCookie("formEmails", formData.officialEmail);
        }


    if (!formData.name) {
      toast.error("Please enter your name");
      setError((prevErrors) => ({
        ...prevErrors,
        name: true,
      }));
      return false;
    } else if (nameTest || isBlank(formData.name)) {
      toast.error(
        "Name field cannot contain number, special characters, or blank space"
      );
      setError((prevErrors) => ({
        ...prevErrors,
        name: true,
      }));
      return false;
    } else if (!formData.companyName) {
      toast.error("Please enter your company name");
      setError((prevErrors) => ({
        ...prevErrors,
        name: false,
        companyName: true,
      }));
      return false;
    } else if (companyNameTest) {
      setError((prevErrors) => ({
        ...prevErrors,
        name: false,
        companyName: true,
      }));
      toast.error("Company field cannot contain number or special characters");
      return false;
    } else if (!formData.officialEmail) {
      toast.error("Please enter a valid email address");
      setError((prevErrors) => ({
        ...prevErrors,
        name: false,
        companyName: false,
        officialEmail: true,
      }));
      return false;
    } else if (!officialEmailTest) {
      setError((prevErrors) => ({
        ...prevErrors,
        name: false,
        companyName: false,
        officialEmail: true,
      }));
      toast.error("Please enter your official email address.");
      return false;
    } else if (phoneValue.length <= 4) {
      setError((prevErrors) => ({
        ...prevErrors,
        name: false,
        officialEmail: false,
        message: false,
        contactNo: true,
      }));
      toast.error("Phone number is required");
      return false;
    } else if (!isValidPhoneNumber(phoneValue)) {
      setError((prevErrors) => ({
        ...prevErrors,
        name: false,
        officialEmail: false,
        message: false,
        contactNo: true,
      }));
      toast.error("Please enter a valid phone number");
      return false;

    } else if (storedScheduleEmails?.includes(formData.officialEmail) && isScheduleMeeting) {
      //16-Sep-2026 Rahul-Venu asked for repetitive email access to be allowed.
      //toast.error(
      //  "Your request has already been applied, please try again tomorrow. "
      //);
      return true;
    } else if (
      storedFormEmails?.includes(formData.officialEmail) &&
      isformSubmitted
    ) {
      toast.error(
        "Your request has already been applied, please try again tomorrow. "
      );
      return false;
    } else {
      setError((prevErrors) => ({
        ...prevErrors,
        contactNo: false,
      }));
      setValidation(true);
      if (isScheduleMeeting) {
        setIsSubmit(true);
        return false; // Stop further execution
      }
      // setIsSubmitClicked(false)

      return true;
    }
  };

  const isValid = await validateForm();

  if (!isValid) {
    setIsLoading(false);
    return;
  }

  setIsLoading(true);

  const response = await fetch("/api/contact-form", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });

  const result = await response.json();

  setTimeout(() => {
    setIsLoading(false);
    setEmailSent(true);
  }, 3000)


  if (result.success) {
    setIsLoading(false);
    setEmailSent(true);
    setSelectedHour(null);
    setPhoneValue(null);
    setAccordionOpen(false);
    setSelected(null);
  } else {
    toast.error(`Error sending email: ${result.error}`);
    setIsLoading(false);
  }

  setErrorMessage("");
  setSuccessMessage("Email successfully submitted!");
  setFormData({
    name: "",
    companyName: "",
    officialEmail: "",
    contactNo: "",
    message: "",
    meetingDate: "",
    scheduleMeeting: "",
    startTime: "",
    endTime: "",
    timeZone: "",
    hour: "",
  });
  setError({
    name: false,
    companyName: false,
    officialEmail: false,
    contactNo: false,
    message: false,
    meetingDate: false,
    scheduleMeeting: false,
    startTime: false,
    endTime: false,
    timeZone: false,
    hour: false,
  });
};


  const handleCountryHour = (selectedHourOption: any) => {
    setSelectedHour(selectedHourOption);
    setFormData({
      ...formData,
      hour: selectedHourOption ? selectedHourOption : "",
    });
  };

  const handleIsSubmit = () => {
    setIsSubmit(!isSubmit);
  };

  useEffect(() => {
    const button = document.querySelector(
      ".react-international-phone-country-selector-button"
    );
    if (button) {
      button.setAttribute("tabindex", "-1");
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setEmailSent(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  useEffect(() => {
    if (emailSent) {
      const timer = setTimeout(() => {
        setEmailSent(false);
        router.push("/");
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [emailSent]);

  const indianTime = HOURS_ARRAY;

  const convertTimesToTimeZone = (timesArray: any, selectedTimeZone: any) => {
    return timesArray.map((time: any) => {
      const dateTimeString = `${time}:00+05:30`;
      return moment
        .tz(dateTimeString, "HH:mm:ssZ", "Asia/Kolkata")
        .tz(selectedTimeZone)
        .format("HH:mm");
    });
  };

  return (
    <div className="flex items-center scroll-div justify-center lg:max-w-[900px] 2xl:max-w-[950px]  3xl:max-w-[1100px]  5xl:max-w-[1800px] 6xl:max-w-[2000px] px-6 mx-auto contact-form w-full pb-10 lg:pb-20">
      <Toaster />
      {!isSubmit ? (
        <div className="w-full px-4 bg-white lg:px-16 py-14 shadow-primary rounded-3xl sm:px-10 max-lg:py-9">
          {/* Contact Form Header */}
          <div className="w-full h-auto">
            {/* <h2 className="font-semibold text-[#032D60] !text-4xl lg:!text-5xl">
            Let's Connect
          </h2> */}
            <h3 className=" text-[#032D60] text-[2rem] leading-10 mt-6  ">
              Let's connect
            </h3>

        
          </div>

          {/* Contact Form */}

          <form
            className="contact-form-wrapper"
            // onSubmit={handleSubmit}
            onSubmit={(e) => handleSubmit(e, false,true)}
            autoComplete="off"
          >
            <div className="relative flex items-center gap-3 my-4 lg:my-8">
              <img
                className="w-6 h-6 lg:w-4 lg:h-4"
                src="/images/contactOne.svg"
                alt=""
              />
              <div className="w-full ">
                <input
                  autoComplete="off"
                  id="name"
                  // pattern="[A-Za-z ]{1,32}"
                  value={formData.name}
                  onChange={handleInputChange}
                  className={`input-primary ${
                    error.name ? "border-b !border-red-500 rounded" : ""
                  } `}
                  type="text"
                  placeholder="Name*"
                  onInvalid={(e) =>
                    (e.target as HTMLInputElement).setCustomValidity(
                      "This field is required"
                    )
                  }
                  onInput={(e) =>
                    (e.target as HTMLInputElement).setCustomValidity("")
                  }
                  required
                />
              </div>
            </div>
            {/* Company Name & Designation Inputs */}
            {/* <div className="flex flex-col w-full gap-5 my-4 sm:flex-row lg:my-8"> */}
            <div className="flex items-center w-full gap-3">
              <img
                className="w-6 h-6 lg:w-4 lg:h-4"
                src="/images/contactTwo.svg"
                alt=""
              />

              <input
                id="companyName"
                autoComplete="off"
                // pattern="[A-Za-z ]{1,32}"
                value={formData.companyName}
                onChange={handleInputChange}
                className={`input-primary ${
                  error.companyName ? "border-b !border-red-500 rounded" : ""
                } `}
                type="text"
                placeholder="Company Name*"
                onInvalid={(e) =>
                  (e.target as HTMLInputElement).setCustomValidity(
                    "This field is required"
                  )
                }
                onInput={(e) =>
                  (e.target as HTMLInputElement).setCustomValidity("")
                }
                required
              />
            </div>
            {/* Official Email Input */}
            <div className="flex items-center gap-3 my-4 lg:my-8">
              <img
                className="w-6 h-6 lg:w-4 lg:h-4"
                src="/images/contactThree.svg"
                alt=""
              />

              <input
                id="officialEmail"
                autoComplete="off"
                value={formData.officialEmail}
                onChange={handleInputChange}
                className={`w-full input-primary placeholder:text-[#818181] placeholder:text-sm focus:outline-none bg-white ${
                  error.officialEmail ? "border-b !border-red-500" : ""
                }`}
                type="email"
                placeholder="Official Email*"
                required
                onInvalid={(e) =>
                  (e.target as HTMLInputElement).setCustomValidity(
                    "Please enter a valid email address"
                  )
                }
                onInput={(e) =>
                  (e.target as HTMLInputElement).setCustomValidity("")
                }
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$"
              />
            </div>
            {/* Contact Number Input */}
            <div className="flex items-center gap-3 my-4 lg:my-8">
              <img
                className="w-6 h-6 lg:w-4 lg:h-4"
                src="/images/contactFour.svg"
                alt=""
              />
              <div className="relative flex items-center w-full !p-0 input-primary">
                <PhoneInput
                  defaultCountry="us"
                  preferredCountries={["us", "in", "gb", "au"]}
                  value={phoneValue || ""}
                  onChange={(phone: any) => {
                    setPhoneValue(phone);

                    setFormData({ ...formData, contactNo: `${phone}` });
                  }}
                  inputProps={{
                    required: true,
                    placeholder: "Phone No",
                    tabIndex: 0,
                    onInvalid: (e) =>
                      (e.target as HTMLInputElement).setCustomValidity(
                        "This field is required"
                      ),
                    onInput: (e) =>
                      (e.target as HTMLInputElement).setCustomValidity(""),
                  }}
                  inputClassName="contact-field"
                  inputStyle={{ border: "none" }}
                  countrySelectorStyleProps={{
                    buttonStyle: {
                      border: "none",
                    },
                  }}
                  className={`!w-full sm:!w-9/12 lg:!w-11/12 border-none" ${
                    error.contactNo ? "border-b !border-red-500" : " "
                  }`}
                />
              </div>
            </div>
            {/* Message Textarea */}
            <div className="flex gap-2 my-4 lg:my-8">
              <div className="w-full mt-1 ">
                <div className="flex items-center gap-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="54"
                    height="53"
                    viewBox="0 0 54 53"
                    className="w-6 h-6 lg:w-4 lg:h-4"
                  >
                    <defs>
                      <clipPath id="clip-Message">
                        <rect width="54" height="53" />
                      </clipPath>
                    </defs>
                    <g id="Message" clipPath="url(#clip-Message)">
                      <g id="g2682" transform="translate(1.489 683.823)">
                        <g id="g2684" transform="translate(0 -682.665)">
                          <g id="g2686">
                            <g id="g2692" transform="translate(1.502 1.502)">
                              <path
                                id="path2694"
                                d="M-435.309-402.877v12.55a3,3,0,0,1-3,3h-29.347a3,3,0,0,1-3-3v-42.267a3,3,0,0,1,3-3h29.347a3,3,0,0,1,3,3v20.607"
                                transform="translate(470.665 435.599)"
                                fill="none"
                                stroke="#818181"
                                strokeLinecap="round"
                                strokeWidth="3"
                              />
                            </g>
                            <g id="g2696" transform="translate(24.805 16.827)">
                              <path
                                id="path2698"
                                d="M-48.831-201.614-32.9-217.549a1.5,1.5,0,0,1,1.063-.441,1.5,1.5,0,0,1,1.063.441l2.508,2.508a1.5,1.5,0,0,1,.441,1.063,1.5,1.5,0,0,1-.441,1.062L-44.3-197.082l-8.5,3.966Z"
                                transform="translate(52.797 217.989)"
                                fill="none"
                                stroke="#818181"
                                strokeLinecap="round"
                                strokeWidth="3"
                              />
                            </g>
                            <g id="g2700" transform="translate(41.236 20.737)">
                              <path
                                id="path2702"
                                d="M0,0,4.533,4.533"
                                fill="none"
                                stroke="#818181"
                                strokeLinecap="round"
                                strokeWidth="3"
                              />
                            </g>
                            <g id="g2704" transform="translate(8.013 11.218)">
                              <path
                                id="path2706"
                                d="M0,0H22.436"
                                fill="none"
                                stroke="#818181"
                                strokeLinecap="round"
                                strokeWidth="3"
                              />
                            </g>
                            <g id="g2708" transform="translate(8.013 19.231)">
                              <path
                                id="path2710"
                                d="M0,0H17.628"
                                fill="none"
                                stroke="#818181"
                                strokeLinecap="round"
                                strokeWidth="3"
                              />
                            </g>
                            <g id="g2712" transform="translate(8.013 27.243)">
                              <path
                                id="path2714"
                                d="M0,0H12.82"
                                fill="none"
                                stroke="#818181"
                                strokeLinecap="round"
                                strokeWidth="3"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>

                  <label
                    className="text-[#818181] !text-base inline-block"
                    htmlFor="message"
                  >
                    Please share your current challenges to help us customize
                    your demonstration.
                  </label>
                </div>
                <div className="mt-2 pl-9 lg:pl-6">
                  <textarea
                    id="message"
                    autoComplete="off"
                    value={formData.message}
                    onInvalid={(e) =>
                      (e.target as HTMLInputElement).setCustomValidity(
                        "This field is required"
                      )
                    }
                    onInput={(e) =>
                      (e.target as HTMLInputElement).setCustomValidity("")
                    }
                    onChange={(e) =>
                      setFormData({ ...formData, message: e.target.value })
                    }
                    className={` ${
                      error.message ? "border !border-red-500" : ""
                    } textarea-primary resize-none px-2 lg:ms-[2px]`}
                  />
                </div>
               
                <div>
                  <h3 className=" text-[#032D60] text-[2rem] leading-10 mt-8  ">
                    Pick a date and time, let's do this!
                  </h3>
                  <div
                  
                    onClick={(e) => handleSubmit(e, true,false)}
                    className="flex items-center my-4 lg:my-6"
                  >
                    <div className="flex items-center w-full gap-3">
                      <img
                        src="/images/contactSeven.svg"
                        className="w-6 h-6 lg:w-4 lg:h-4"
                        alt=""
                      />
                      <div
                        tabIndex={0}
                        className={`flex items-center justify-between px-1 py-3 -ml-1 cursor-pointer  input-secondary ${
                          accordionOpen ? "" : "focus:outline-[#032D60]"
                        }`}
                        onClick={() => setAccordionOpen(!accordionOpen)}
                      >
                        <span className="!text-[0.9375rem] font-medium text-[#032d60]">
                          Schedule your customized demonstration
                        </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className={`h-4 w-4 text-[#032d60] transform transition-transform ${
                            accordionOpen ? "rotate-180" : ""
                          }`}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>
                   
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
            
            {/* schedule a meeting */}
            {/* Submit Button */}
            <div className="flex justify-end">
              <button
                className="px-4 py-2 font-medium text-white bg-[#0095eb] rounded-full"
                type="submit"
              >
                {isloading && (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 mr-3 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    ></path>
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                )}
                Submit
              </button>
            </div>
            {emailSent && (
              <div className="fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-50 z-50 p-0">
                <div>
                  <div
                    ref={modalRef}
                    className="flex w-full max-w-sm px-4 py-8 lg:!p-10 mx-2 bg-white shadow-lg sm:max-w-lg md:max-w-xl lg:max-w-xl xl:max-w-2xl md:mx-4 lg:mx-6 border-4 border-[#50b1e4] rounded-xl"
                  >
                    <div className="flex flex-col items-start justify-center gap-4 text-center lg:flex-row lg:text-left">
                      <div className="self-center lg:self-start">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="#50b1e4"
                          className="h-auto w-14 lg:w-10"
                        >
                          <path
                            fillRule="evenodd"
                            d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                      <div>
                        <h2 className="mb-2 text-lg font-semibold lg:text-2xl">
                          Thank you for your interest.
                        </h2>
                        <p className="text-base">
                          We will get back to you shortly!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          
          </form>
        </div>
      ) : (
        <div className="w-full px-4 bg-white lg:px-0 py-14 lg:py-0 shadow-primary rounded-3xl sm:px-10 max-lg:py-9">
          <InlineWidget
            prefill={{
              name: formData.name,
              email: formData.officialEmail,
              customAnswers: {
                a1: formData.companyName,
                a2: phoneValue,
                a3: formData.message,
              },
            }}
            url="https://calendly.com/d/cwzx-cxc-zrw/qualitia-boson-demonstration-updated"
          />
        </div>
      )}
    </div>
  );
}
